import styled from 'styled-components';

import BREAKPOINTS from 'styles/breakpoints';
import { rem } from 'styles/typography';
import { P1, weight } from 'styles/typography';

import ImageSlider from '../ImageSlider';

const HeadingContent = styled.div`
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 800px;
  margin: auto;
  text-align: center;

  ${BREAKPOINTS.xsmall`
    padding-top: 150px;
  `}
`;

const HeadingParagraph = styled.div`
  max-width: 440px;
  padding: 40px var(--gutter-side) 55px;

  * {
    text-align: center;
  }

  ${BREAKPOINTS.small`
    padding: 55px var(--gutter-side) 75px;
    font-size: ${rem(50)};
  `}
`;

const Heading = styled.h2`
  font-size: ${rem(30)};
  line-height: ${rem(36)};
  padding: 0 var(--gutter-side);
  font-weight: ${weight.black};

  ${BREAKPOINTS.xsmall`
    font-size: ${rem(40)};
    line-height: ${rem(46)};
  `}

  ${BREAKPOINTS.medium`
    font-size: ${rem(70)};
    line-height: ${rem(76)};
  `}
`;

const WhatsOnImageSlider = ({
  headingFirst,
  headingSecond,
  headingCopy,
  imageSlider,
}) => {
  return (
    <>
      <HeadingContent>
        <Heading>{headingFirst}</Heading>
        <Heading>{headingSecond}</Heading>

        <HeadingParagraph>
          <P1>{headingCopy}</P1>
        </HeadingParagraph>
      </HeadingContent>

      <ImageSlider images={imageSlider.images} />
    </>
  );
};

export default WhatsOnImageSlider;
